export async function ExpmedicaUpdate(
  expmedResp,
  expmedFecha,
  expmedTipo,
  expmedPeso,
  expmedTalla,
  expmedTemp,
  expmedSo2,
  expmedAspgen,
  expmedOjo,
  expmedNariz,
  expmedBoca,
  expmedOido,
  expmedPiel,
  expmedFaner,
  expmedMucos,
  expmedOrofar,
  expmedCuello,
  expmedTronc,
  expmedExtrem,
  expmedAusc,
  expmedMvesic,
  expmedVentbas,
  expmedRresp,
  expmedFrecresp,
  expmedTasent,
  expmedAusccard,
  expmedFreccard,
  expmedRcard,
  expmedRuidos,
  expmedElectroc,
  expmedPulscarot,
  expmedPulyug,
  expmedInspvenart,
  expmedInpecc,
  expmedPalp,
  expmedAuscdig,
  expmedPercus,
  expmedInspurog,
  expmedLocom,
  expmedExplrefl,
  expmedReflpup,
  expmedRefrot,
  expmedSigmen,
  expmedParcran,
  expmedSubconj,
  expmedTelang,
  expmedEritpalm,
  expmedGinec,
  expmedTembdist,
  expmedEdmal,
  expmedRetpalm,
  expmedHipparot,
  expmedAtdergen,
  expmedJuicclin,
  tratamientoId,
  pacienteId,
  expmedicaId
) {
  const formData = {
    title: `us-${pacienteId}-tr-${tratamientoId}-expmed-${expmedFecha}`,
    slug: `us-${pacienteId}-tr-${tratamientoId}-expmed-${expmedFecha}`,
    status: "publish",
    tratamiento: tratamientoId,
    paciente: pacienteId,
    meta: {
      expmedResp: expmedResp,
      metaFecha: expmedFecha,
      expmedTipo: expmedTipo,
      expmedPeso: expmedPeso,
      expmedTalla: expmedTalla,
      expmedTemp: expmedTemp,
      expmedSo2: expmedSo2,
      expmedAspgen: expmedAspgen,
      expmedOjo: expmedOjo,
      expmedNariz: expmedNariz,
      expmedBoca: expmedBoca,
      expmedOido: expmedOido,
      expmedPiel: expmedPiel,
      expmedFaner: expmedFaner,
      expmedMucos: expmedMucos,
      expmedOrofar: expmedOrofar,
      expmedCuello: expmedCuello,
      expmedTronc: expmedTronc,
      expmedExtrem: expmedExtrem,
      expmedAusc: expmedAusc,
      expmedMvesic: expmedMvesic,
      expmedVentbas: expmedVentbas,
      expmedRresp: expmedRresp,
      expmedFrecresp: expmedFrecresp,
      expmedTasent: expmedTasent,
      expmedAusccard: expmedAusccard,
      expmedFreccard: expmedFreccard,
      expmedRcard: expmedRcard,
      expmedRuidos: expmedRuidos,
      expmedElectroc: expmedElectroc,
      expmedPulscarot: expmedPulscarot,
      expmedPulyug: expmedPulyug,
      expmedInspvenart: expmedInspvenart,
      expmedInpecc: expmedInpecc,
      expmedPalp: expmedPalp,
      expmedAuscdig: expmedAuscdig,
      expmedPercus: expmedPercus,
      expmedInspurog: expmedInspurog,
      expmedLocom: expmedLocom,
      expmedExplrefl: expmedExplrefl,
      expmedReflpup: expmedReflpup,
      expmedRefrot: expmedRefrot,
      expmedSigmen: expmedSigmen,
      expmedParcran: expmedParcran,
      expmedSubconj: expmedSubconj,
      expmedTelang: expmedTelang,
      expmedEritpalm: expmedEritpalm,
      expmedGinec: expmedGinec,
      expmedTembdist: expmedTembdist,
      expmedEdmal: expmedEdmal,
      expmedRetpalm: expmedRetpalm,
      expmedHipparot: expmedHipparot,
      expmedAtdergen: expmedAtdergen,
      expmedJuicclin: expmedJuicclin,
    },
  };

  const authToken = sessionStorage.getItem("token");

  try {
    const response = await fetch(
      `https://app.tavad.com/hce/wp-json/wp/v2/explmedica/${expmedicaId}`,
      {
        method: "POST",
        headers: {
          Accept: "application/json",
          "Content-Type": "application/json",
          Authorization: `Bearer ${authToken}`,
        },
        body: JSON.stringify(formData),
      }
    );
    const values = await response.json();
    console.log(values);
    return values;
  } catch (error) {
    console.error(error);
  }
}
